import { IComponentOptions } from "angular";
import { ChangeJournalViewComponentItemController } from "../../../../../records/changeJournal/changeJournalViewComponent/itemObjectDetail/componentController";

export const vsComponentName = "changeJournalMachineItemView";
export const changeJournalMachineItemViewComponentOptions: IComponentOptions = {
  template: require("!html-loader!./index.html").default,
  controllerAs: "itemController",
  controller: ChangeJournalViewComponentItemController,
  bindings: {
    logItem: "<",
  },
};
